(function () {
    'use strict';

    run.admin.parts.rackootManageTiles = function() {
        const csrf_name = document.getElementsByName('csrf_name')[0].value;
        const csrf_value = document.getElementsByName('csrf_value')[0].value;

        // Add tool
        // document.body.addEventListener('click', function(e) {
        //     let suggested_tool = e.target.closest('.tool_click_add');
        //     if (suggested_tool) {
        //         addTool(suggested_tool.dataset.toolUuid);
        //     }
        // });

        // Add custom tool
        // const btn_add_custom_tool = document.getElementById('btn__add_custom_tool');
        const btn_add_custom_tool = document.getElementById('btn_new_menu');
        if (btn_add_custom_tool != null) {
            btn_add_custom_tool.addEventListener('click', function(e) {
                createCustomTool();
            });
        }

        const sortable_tools = document.getElementById('tool_group__active');
        // const sortable_tools = active_container.querySelector('.tool');
        // console.log(sortable_tools);
        const sortable = new Sortable(sortable_tools, {
            animation: 150,
            ghostClass: 'dragging',
            draggable: ".item_draggable",
            delay: 100,
            delayOnTouchOnly: true,
            // handle: ".tool__drag",
            store: {
                set: function(sorted) {
                    saveSorted();
                }
            }
        });

        function saveSorted()
        {
            let getSortedTools = sortable_tools.querySelectorAll('.tool');
            const sortedToolsOrder = Array.prototype.map.call(getSortedTools, (el, index) => {
                return el.id;
            });
            axios.post(GlobalRoutes.rackoots.tiles_reorder, {csrf_name: csrf_name, csrf_value: csrf_value, rackoot_uuid: document.getElementById('rackoot_data').dataset.uuid, order:sortedToolsOrder})
            .then(function (response) {
                // new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
            })
            .catch(function (error) {
                new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
            });
        }

        function addTool(tool_uuid, edit_after = false) {
            const values = {
                csrf_name: csrf_name,
                csrf_value: csrf_value,
                tool_uuid: tool_uuid,
                rackoot_uuid: document.getElementById('btn_new_menu').dataset.rackootUuid,
            }

            // Add placeholder
            let newToolItem = document.getElementById('tool_template').innerHTML;
            newToolItem = replaceAll(newToolItem, {
                '{name}':translations.tiles.add.messages.adding,
                '{icon}':'',
                '{initials}':'',
                "{bg}":'#ffffff',
                "{color}":'#3372b9',
                "{url}":'#',
                "{description}":'',
                "{uuid}":'adding_tool_placeholder',
            });
            let tools_container = document.getElementById('tool_group__active');
            // tools_container.insertAdjacentHTML('beforeend', newToolItem);
            const placeholders = tools_container.querySelectorAll('.tool__placeholder');
            placeholders[0].insertAdjacentHTML('beforebegin', newToolItem);


            // Request new
            axios.post(GlobalRoutes.tools.add, values)
            .then(function (response) {
                let newToolItem = document.getElementById('tool_template').innerHTML;
                newToolItem = replaceAll(newToolItem, {
                    '{name}':response.data.tool.name,
                    '{icon}':(response.data.tool.icon === null) ? '' : response.data.tool.icon,
                    "{bg}":response.data.tool.background,
                    "{color}":response.data.tool.color,
                    "{url}":response.data.tool.url,
                    "{description}":(response.data.tool.description === null) ? '' : response.data.tool.description,
                    "{uuid}":response.data.tool.uuid,
                });

                // remove placeholder
                const placeholder = document.getElementById('adding_tool_placeholder');
                if (placeholder !== null) {
                    document.getElementById('adding_tool_placeholder').remove();
                }

                // Add new
                let tools_container = document.getElementById('tool_group__active');
                // tools_container.insertAdjacentHTML('beforeend', newToolItem);
                const placeholders = tools_container.querySelectorAll('.tool__placeholder');
                placeholders[0].insertAdjacentHTML('beforebegin', newToolItem);

                setTimeout(() => {                            
                    let newToolInserted = tools_container.getElementsByClassName('adding')[0];
                    newToolInserted.classList.remove('adding');
                }, 300);
                saveSorted();

                if (edit_after == true) {
                    // const lastInserted = Array.from(
                    //     tools_container.querySelectorAll('.tool')
                    //   ).pop();
                    const lastInserted = document.getElementById(response.data.tool.uuid);
                    editTool(lastInserted);
                }
            })
            .catch(function (error) {
                // remove placeholder
                const placeholder = document.getElementById('adding_tool_placeholder');
                if (placeholder !== null) {
                    document.getElementById('adding_tool_placeholder').remove();
                }
                // document.getElementById('adding_tool_placeholder').remove();
                new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
            });
        }

        // Create custom
        async function createCustomTool(props = {})
        {
            const rackoot_data = document.getElementById('rackoot_data');
            const rackoot_uuid = rackoot_data.dataset.uuid;

            let create_tool_template = document.getElementById('create_tool_template').innerHTML;
            const random_color = random_colors[Math.floor(Math.random()*random_colors.length)];
            let new_url = '';
            if (props.hasOwnProperty('url')) {
                if (isValidHttpUrl(props.url)) {
                    new_url = props.url;
                }
            }

            create_tool_template = replaceAll(create_tool_template, {
                "{color}": random_color,
                "{url}": new_url,
            });

            const { value: createToolValues } = await Swal.fire({
                title: translations.tiles.add.messages.title,
                html: create_tool_template,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.tiles.add.messages.buttonCancel,
                confirmButtonText: translations.tiles.add.messages.buttonConfirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                },
                didOpen: () => {
                    setIconPicker();
                    const url_input = document.getElementById('form_tool_edit__url');
                    const url_parse_button = document.getElementById('create_custom_tool__extract_data');
                    url_input.addEventListener('input', function(e) {
                        if (url_input.value.length > 5) {
                            url_parse_button.disabled = false;
                        } else {
                            url_parse_button.disabled = true;
                        }
                    });

                    if (props.url !== null && isValidHttpUrl(props.url)) {
                        url_parse_button.disabled = false;
                        url_parse_button.click();
                    }
                },
                preConfirm: () => {
                    if (
                        !document.getElementById('form_tool_edit__name').value ||
                        !document.getElementById('form_tool_edit__url').value
                    ) {
                        Swal.showValidationMessage('Please complete all the fields')
                    } else {
                        return [
                            document.getElementById('form_tool_edit__name').value,
                            document.getElementById('form_tool_edit__url').value,
                            document.getElementById('form_tool_edit__description').value,
                            document.getElementById('form_tool_edit__color').value,
                            document.getElementById('form_tool_edit__background').value,
                            document.getElementById('form_tool_edit__icon').value,
                            document.getElementById('form_tool_edit__force_icon').checked,
                            // tool_element.dataset.forceIcon = values.force_icon ? 1 : 0;
                        ]
                    }
                }
            })
              
            if (createToolValues) {
                var data = new FormData();
                data.append('csrf_name', csrf_name);
                data.append('csrf_value', csrf_value);
                data.append('rackoot_uuid', rackoot_uuid);
                data.append('name', createToolValues[0]);
                data.append('url', createToolValues[1]);
                data.append('description', createToolValues[2]);
                data.append('color', createToolValues[3]);
                data.append('background', createToolValues[4]);
                data.append('icon', createToolValues[5]);
                data.append('force_icon', createToolValues[6]);

                axios.post(GlobalRoutes.tools.add_custom, data)
                .then(function (response) {
                    insertTile(response.data.tool);
                })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });    
            }
        }

        function insertTile(tileData = {})
        {
            const name = tileData.name;
            const icon = (tileData.hasOwnProperty('icon')) ? tileData.icon : null;
            const initials = (tileData.hasOwnProperty('initials')) ? tileData.initials : null;
            const background = (tileData.hasOwnProperty('background')) ? tileData.background : '#ffffff';
            const color = (tileData.hasOwnProperty('color')) ? tileData.color : '#000000';
            const url = tileData.url;
            const description = (tileData.hasOwnProperty('description')) ? tileData.description : null;
            const uuid = tileData.uuid;
            const force_icon = (tileData.hasOwnProperty('force_icon')) ? tileData.force_icon : 'false';

            let newToolItem = document.getElementById('custom_tool_template').innerHTML;
            newToolItem = replaceAll(newToolItem, {
                '{name}': name,
                '{icon}': (icon === null) ? '' : icon,
                '{initials}': initials,
                "{bg}": background,
                "{color}": color,
                "{url}": url,
                "{description}": description,
                "{uuid}": uuid,
                "{force_icon}": force_icon,
            });
            let tools_container = document.getElementById('tool_group__active');

            // Insert after last active tile, before Suggested and Add new button
            const placeholders = tools_container.querySelectorAll('.tool__placeholder');
            placeholders[0].insertAdjacentHTML('beforebegin', newToolItem);

            let newToolInserted = tools_container.getElementsByClassName('adding')[0];
            if (description === null) {
                newToolInserted.dataset.hasDescription = 'false';
            }
            if (icon === null) {
                newToolInserted.querySelector('.tool__icon').classList.add('d-none');
                newToolInserted.querySelector('.tool__initials').classList.remove('d-none');
            }

            setTimeout(() => {                            
                newToolInserted.classList.remove('adding');
            }, 300);

            appendFaviconToTile(newToolInserted);

            saveSorted();

            return newToolInserted;
        }

        // Add tool from library
        document.body.addEventListener('click', function(e) {
            let btn_add_from_library = e.target.closest('#btn__add_from_library');
            if (btn_add_from_library) {
                axios.get(GlobalRoutes.tools.get_library)
                .then(function (response) {
                    const list = document.getElementById('from_tools_library_list');
                    list.innerHTML = '';

                    // Search
                    let search_container = document.createElement('div');
                    search_container.id = 'tools_library__search_container';
                    let search_input = document.createElement('input');
                    search_input.type = 'text';
                    search_input.placeholder = translations.tiles.library.search;
                    search_input.id = 'tools_library__search_input';
                    search_input.classList.add('form-control');
                    search_container.appendChild(search_input);
                    list.appendChild(search_container);

                    // Items
                    const grid = document.createElement('div');
                    grid.id = 'tools_library';

                    Object.keys(response.data).forEach(function(key){
                        let item = document.createElement('div');
                        let item_data = response.data[key];
                        item.classList.add('tools_library__item');
                        item.dataset.itemUuid = item_data.uuid;
                        item.style.setProperty('--color', item_data.color);
                        item.style.setProperty('--bg-color', item_data.background);
                        item.innerHTML = `<i class="`+item_data.icon+`"></i> `+item_data.name;
                        grid.appendChild(item);
                    });
                    list.appendChild(grid);

                    let all_items = grid.querySelectorAll('.tools_library__item');
                    for (let i = 0; i < all_items.length; i++) {
                        if (all_items !== null) {
                            // Start
                            all_items[i].addEventListener("click", function(e) {
                                const el = e.currentTarget;
                                const tool_uuid = el.dataset.itemUuid;
                                addTool(tool_uuid, document.getElementById('tools_library__edit_after_create').checked);
                                Swal.close();
                            });
                        }
                    }

                    // Options
                    let checkboxes_container = document.createElement('div');
                    checkboxes_container.id = 'tools_library__options';
                    
                    // Edit after inserting
                    const checked = window.localStorage.getItem('tile_edit_after_insert');
                    let check_container = document.createElement('div');
                    check_container.classList.add('form-check');
                    let label = document.createElement('label');
                    label.innerHTML = translations.tiles.library.messages.editAfterInserting;
                    label.classList.add('form-check-label');
                    label.setAttribute('for', 'tools_library__edit_after_create');
                    let check_edit_after = document.createElement('input');
                    check_edit_after.type = 'checkbox';
                    if (checked != 'undefined' && checked == 'false') {
                    } else {
                        check_edit_after.setAttribute('checked', 'checked');
                    }
                    check_edit_after.id = 'tools_library__edit_after_create';
                    check_edit_after.classList.add('form-check-input', 'toggle');
                    check_edit_after.dataset.toggle = 'toggle';
                    check_container.appendChild(check_edit_after);
                    check_container.appendChild(label);
                    checkboxes_container.appendChild(check_container);
                    list.appendChild(checkboxes_container);

                    // Listen to checkbox change
                    document.body.addEventListener('change', function(e) {
                        if (e.target && e.target.id== 'tools_library__edit_after_create') {
                            window.localStorage.setItem('tile_edit_after_insert', e.target.checked, 180);
                        }
                    });
            
                    // Handle search
                    search_input.addEventListener('input', function (e) {
                        const filter_text = e.target.value.toLowerCase();
                        for (let i = 0; i < all_items.length; i++) {
                            if (all_items !== null) {
                                let itemName = all_items[i].textContent;
                                if (itemName.toLowerCase().indexOf(filter_text) > -1) {
                                all_items[i].style.display = "";
                                } else {
                                all_items[i].style.display = "none";
                                }
                            }
                        }
                    })

                })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });

                Swal.fire({
                    title: translations.tiles.library.messages.title,
                    html: `
                        <form name="tool_add_from_library" id="form_tool_add_from_library">
                            <div id="from_tools_library_list">
                                `+translations.tiles.library.messages.loading+`
                            </div>
                        </form>
                    `,
                    showCloseButton: false,
                    showCancelButton: true,
                    showConfirmButton: false,
                    focusCancel: true,
                    cancelButtonText: translations.tiles.library.messages.buttonCancel,
                    buttonsStyling: false,
                    reverseButtons: true,
                    width: '70%',
                    customClass: {
                        cancelButton: 'btn btn-lg btn-light',
                    },
                    showClass: {
                        popup: 'animate__animated animated__fast animate__fadeInUp'
                    },
                    hideClass: {
                        popup: 'animate__animated animated__fast animate__fadeOutDown'
                    }
                }).then((result) => {
                });
            }
        });

        // Remove tool
        document.body.addEventListener('click', function(e) {
            let selected_tool = e.target.closest('.tool__delete');
            if (selected_tool) {
                const tool = selected_tool.closest('.tool');
                deleteTool(tool);
            }
        });
        
        // Edit tool
        document.body.addEventListener('click', function(e) {
            let selected_tool = e.target.closest('.tool__edit');
            if (selected_tool) {
                const tool = selected_tool.closest('.tool');
                editTool(tool);
            }
        });

        // Clone tile
        document.body.addEventListener('click', function(e) {
            let selected_tool = e.target.closest('.tool__clone');
            if (selected_tool) {
                const tool = selected_tool.closest('.tool');
                cloneTool(tool);
            }
        });
        
        // Delete tile
        function deleteTool(tool_element) {
            let button_delete = tool_element.getElementsByClassName('tool__delete')[0];
            let tool_name = tool_element.dataset.toolName;

            Swal.fire({
                title: translations.tiles.delete.messages.title,
                html: translations.tiles.delete.messages.body.replace("{tile_name}", tool_name),
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.tiles.delete.messages.buttonCancel,
                confirmButtonText: translations.tiles.delete.messages.buttonConfirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-danger ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    const values = {
                        csrf_name: csrf_name,
                        csrf_value: csrf_value,
                        tile_uuid: tool_element.id,
                    }
                    tool_element.classList.add('d-none');
                    axios.post(GlobalRoutes.tools.delete, values)
                    .then(function (response) {
                        tool_element.classList.add('removing');
                        setTimeout(() => {
                            tool_element.remove();
                        }, 300);
                        //new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                    })
                    .catch(function (error) {
                        tool_element.classList.remove('d-none');
                        new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    });
                }
            });
        }

        function cloneTool(tool_element)
        {
            let new_element = tool_element.cloneNode(true);
            const tool_actions = new_element.querySelector('.tool__actions');
            tool_actions.classList.add('d-none');
            tool_element.after(new_element);

            const values = {
                csrf_name: csrf_name,
                csrf_value: csrf_value,
                tile_uuid: tool_element.id,
            }
            axios.post(GlobalRoutes.tools.clone, values)
            .then(function (response) {
                new_element.id = response.data.data.uuid;
                new_element.dataset.toolUuid = response.data.data.uuid;
                tool_actions.classList.remove('d-none');
                editTool(new_element);
            })
            .catch(function (error) {
                new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
            });
        }

        function editTool(tool_element) {
            let name = tool_element.dataset.toolName;
            let tool_display_name = tool_element.getElementsByClassName('tool__name')[0].getElementsByTagName('span')[0].innerText;
            let url = tool_element.getElementsByClassName('tool__visit')[0].getAttribute('href');
            let description = tool_element.getElementsByClassName('tool__description')[0].innerText.trim();
            let color = tool_element.dataset.color;
            let icon = tool_element.dataset.toolIcon;
            let background = tool_element.dataset.background;
            let force_icon = tool_element.dataset.forceIcon;

            tool_display_name = tool_display_name.replace(/"/g, '&quot;');
            description = description.replace(/"/g, '&quot;');

            let edit_tool_template = document.getElementById('edit_tool_template').innerHTML;
            edit_tool_template = replaceAll(edit_tool_template, {
                '{name}': name,
                "{url}": url,
                "{description}": description,
                "{color}": color,
                "{icon}": icon,
                "{background}": background,
                "{force_icon_checked}": (force_icon == "1") ? 'checked="checked"' : '',
            });

            Swal.fire({
                title: translations.tiles.edit.messages.title.replace("{name}", name),
                html: edit_tool_template,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.tiles.edit.messages.buttonCancel,
                confirmButtonText: translations.tiles.edit.messages.buttonConfirm,
                buttonsStyling: false,
                reverseButtons: true,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-primary ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                },
                didOpen: () => {
                    let button_icon_preview = document.getElementById('icon_preview');
                    let button_clear_icon = document.getElementById('clear_icon');
                    if (icon !== null && icon.length > 0) {
                        let icon_container = document.createElement('i');
                        icon_container.className = icon;
                        button_icon_preview.appendChild(icon_container);
                        button_clear_icon.classList.remove('d-none');
                    } else {
                        button_icon_preview.innerHTML = button_icon_preview.dataset.textNoIcon;
                        button_clear_icon.classList.add('d-none');
                    }

                    setIconPicker();
                }
            }).then((result) => {
                if (result.value) {
                    const values = {
                        csrf_name: csrf_name,
                        csrf_value: csrf_value,
                        tile_uuid: tool_element.dataset.toolUuid,
                        name: document.getElementById('form_tool_edit__name').value,
                        url: document.getElementById('form_tool_edit__url').value,
                        description: document.getElementById('form_tool_edit__description').value,
                        icon: document.getElementById('form_tool_edit__icon').value,
                        color: document.getElementById('form_tool_edit__color').value,
                        background: document.getElementById('form_tool_edit__background').value,
                        force_icon: document.getElementById('form_tool_edit__force_icon').checked,
                    }
                    axios.post(GlobalRoutes.tools.edit, values)
                    .then(function (response) {
                        refreshTool(tool_element, values);
                        //new Toast(response.data.message, Toast.TYPE_DONE, Toast.TIME_NORMAL);
                    })
                    .catch(function (error) {
                        new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    });
                }
            });
        }

        const container = document.getElementById('col_main_content');
        container.addEventListener('drop', (e) => {
            e = e || event;
            e.preventDefault();
            var data = e.dataTransfer.getData("text");
            
            if (isValidUrl(data)) {
                createCustomTool({url: data});
            }
        });

        document.body.addEventListener('click', function(e) {
            if (e.target && e.target.id== 'create_custom_tool__extract_data') {
                const url_input = document.getElementById('form_tool_edit__url');
                const title_input = document.getElementById('form_tool_edit__name');
                const desc_input = document.getElementById('form_tool_edit__description');
                const button = document.getElementById('create_custom_tool__extract_data');

                const values = {
                    csrf_name: csrf_name,
                    csrf_value: csrf_value,
                    url: url_input.value,
                }

                button.disabled = true;
                title_input.disabled = true;
                desc_input.disabled = true;
                button.innerText = button.dataset.textLoading;

                document.getElementById('form_tool_edit__name').value = '';
                document.getElementById('form_tool_edit__description').value = '';

                axios.post(GlobalRoutes.tools.parse_url, values)
                .then(function (response) {
                    if (response.data.status == "success") {
                        if (response.data.data.title !== null && response.data.data.title !== 'undefined') {
                            document.getElementById('form_tool_edit__name').value = response.data.data.title;
                        }
                        if (response.data.data.description !== null && response.data.data.description !== 'undefined') {
                            document.getElementById('form_tool_edit__description').value = response.data.data.description;
                        }
                    }
                    button.disabled = false;
                    button.innerText = button.dataset.text;
                    title_input.disabled = false;
                    desc_input.disabled = false;
                    })
                .catch(function (error) {
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                    button.disabled = false;
                    button.innerText = button.dataset.text;
                    title_input.disabled = false;
                    desc_input.disabled = false;
                });
    
            }
        });

        document.body.addEventListener('click', function(e) {
            if (e.target && e.target.id== 'invert_colors') {
                const el_color = document.getElementById('form_tool_edit__color');
                const el_bg = document.getElementById('form_tool_edit__background');
                const current_color_text = el_color.value;
                const current_color_bg = el_bg.value;
                el_color.value = current_color_bg;
                el_bg.value = current_color_text;
            }
        });

        function refreshTool(tool_element, values)
        {
            const tool_name_el = tool_element.getElementsByClassName('tool__name');
            const tool_description_el = tool_element.getElementsByClassName('tool__description');
            const tool_icon_el = tool_element.getElementsByClassName('tool__icon');
            const tool_initials_el = tool_element.getElementsByClassName('tool__initials');
            const tool_links_els = tool_element.getElementsByClassName('tool__visit');
            const tool_icon_i = tool_icon_el[0].querySelector('i');
            
            tool_element.dataset.toolName = values.name;
            tool_element.dataset.description = values.description;
            tool_element.dataset.color = values.color;
            tool_element.dataset.background = values.background;
            tool_element.dataset.forceIcon = values.force_icon ? 1 : 0;
            tool_element.style.setProperty('--bg-color', values.background);
            tool_element.style.setProperty('--color', values.color);

            tool_element.dataset.hasDescription = (values.description) ? "true" : "false";

            if (tool_name_el.length > 0) {
                tool_name_el[0].getElementsByTagName('span')[0].innerHTML = values.name;
                tool_name_el[0].getElementsByTagName('span')[0].style.setProperty('--color', values.color);
            }

            if (tool_description_el.length > 0) {
                tool_description_el[0].innerHTML = values.description;
            }

            if (tool_icon_el.length > 0) {
                tool_icon_el[0].getElementsByTagName('i')[0].style.setProperty('--color', values.color);
            }

            if (tool_initials_el.length > 0) {
                tool_initials_el[0].style.setProperty('--color', values.background);
                tool_initials_el[0].style.setProperty('--bg-color', values.color);
            }

            if (values.icon !== null && values.icon !== 'undefined' && values.icon !== '') {
                tool_icon_el[0].classList.remove('d-none');
                tool_initials_el[0].classList.add('d-none');
                tool_icon_i.className = values.icon;
                tool_element.dataset.toolIcon = values.icon;
            } else {
                tool_icon_i.className = '';
                tool_element.dataset.toolIcon = '';
                tool_icon_el[0].classList.add('d-none');
                tool_initials_el[0].classList.remove('d-none');
            }

            [].forEach.call(tool_links_els, function(link) {
                link.href = values.url;
            });

            appendFaviconToTile(tile);
        }

        function setIconPicker() {
            const el = document.getElementById('form_tool_edit__icon');
            const iconPicker = new IconPicker(el, {
                theme: 'bootstrap-5',
                iconSource: [
                    {
                        key: 'brands',
                        prefix: '',
                        url: GlobalRoutes.appUrl+'/assets/fonts/extra-brands/list.json'
                    },
                    'FontAwesome Solid 5',
                    'FontAwesome Brands 5',
                ],
                closeOnSelect: true,
            });

            const preview_button = document.getElementById('icon_preview');
            const button_clear_icon = document.getElementById('clear_icon');
            
            iconPicker.on('select', instance => {
                let icon = document.createElement('i');
                icon.className = instance.value;
                preview_button.innerHTML = "";
                preview_button.appendChild(icon);
                button_clear_icon.classList.remove('d-none')
            });

            preview_button.addEventListener('click', function(e) {
                e.preventDefault();
                el.click();
            })

            button_clear_icon.addEventListener('click', function(e) {
                preview_button.innerHTML = preview_button.dataset.textNoIcon;
                button_clear_icon.classList.add('d-none');
                el.value = "";
            })
        }

        function AiSuggestionReject(tile)
        {
            let title = replaceAll(translations.ai.suggestions.reject.title, {
                '{name}': tile.dataset.toolName,
            });

            Swal.fire({
                title: title,
                html: translations.ai.suggestions.reject.message,
                showCloseButton: false,
                showCancelButton: true,
                showConfirmButton: true,
                focusCancel: true,
                cancelButtonText: translations.confirmAlerts.close,
                buttonsStyling: false,
                reverseButtons: true,
                cancelButtonText: translations.ai.suggestions.reject.buttonCancel,
                confirmButtonText: translations.ai.suggestions.reject.buttonConfirm,
                customClass: {
                    cancelButton: 'btn btn-lg btn-light',
                    confirmButton: 'btn btn-lg btn-danger ms-4'
                },
                showClass: {
                    popup: 'animate__animated animated__fast animate__fadeInUp'
                },
                hideClass: {
                    popup: 'animate__animated animated__fast animate__fadeOutDown'
                }
            }).then((result) => {
                if (result.value) {
                    tile.classList.add('d-none');
                    var data = new FormData();
                    data.append('csrf_name', csrf_name);
                    data.append('csrf_value', csrf_value);
                    data.append('uuid', tile.dataset.toolUuid);
                
                    tile.classList.remove('d-none');
                
                    axios.post(GlobalRoutes.ai.suggestions.tiles.reject, data)
                        .then(function (response) {
                            tile.remove();
                            loadAiSuggestions(1);
                        })
                        .catch(function (error) {
                            tile.classList.remove('d-none');
                            new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                        });
                    }
            });
        }

        function AiSuggestionAccept(tile)
        {
            const props = {
                name: tile.dataset.toolName,
                url: tile.dataset.url,
                uuid: tile.dataset.toolUuid,
            };

            const newTile = insertTile(props);

            tile.classList.add('d-none');
            var data = new FormData();
            data.append('csrf_name', csrf_name);
            data.append('csrf_value', csrf_value);
            data.append('uuid', tile.dataset.toolUuid);
        
            tile.classList.remove('d-none');
        
            axios.post(GlobalRoutes.ai.suggestions.tiles.approve, data)
                .then(function (response) {
                    tile.remove();
                    loadAiSuggestions(1);
                })
                .catch(function (error) {
                    tile.classList.remove('d-none');
                    newTile.remove();
                    new Toast(error.response.data.error, Toast.TYPE_ERROR, Toast.TIME_NORMAL);
                });
        }

        document.addEventListener('click',function(e) {
            const handle_button = e.target.closest(".button_tool__reject");
            if (!handle_button) return;

            AiSuggestionReject(handle_button.closest('.tool'));
        });

        document.addEventListener('click',function(e) {
            const handle_button = e.target.closest(".button_tool__accept");
            if (!handle_button) return;

            AiSuggestionAccept(handle_button.closest('.tool'));
        });

    }
})();
